import { formatCurrency } from "@ashirbad/js-core";
import MaterialTable from "@material-table/core";
import {
  BarChartOutlined,
  InventoryOutlined,
  LocalOfferOutlined,
  MoneyOutlined,
  Person,
  TimelineOutlined,
} from "@mui/icons-material";
import { Avatar, Chip, Grid } from "@mui/material";
import { InfoCard } from "dashboard/components/dashboard";
import { useIsMounted } from "hooks";
import { useOrdersData, useProducts, useUsers } from "hooks/useDataFetch";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { muiTable } from "utils";
import ReactHtmlParser from "react-html-parser";

const Dashboard = () => {
  const [topProducts, setTopProducts] = useState([]);
  const [newCustomer, setNewCustomer] = useState([]);
  const [recentOrder, setRecentOrder] = useState([]);
  const [totalItemSold, setTotalItemSold] = useState(0);
  const [orderedThisMonth, setOrderThisMonth] = useState(0);

  const [totalUserJoined, setTotalUserJoined] = useState(0);

  const [userThisMonth, setUserThisMonth] = useState(0);

  const [orderToday, setOrderToday] = useState(0);

  const [earningThisMonth, setEarningThisMonth] = useState(0);
  const [earningToday, setEarningToday] = useState(0);

  const [pendingOrder, setPendingOrder] = useState(0);

  const [orderOverViewData, setOrderOverViewData] = useState({
    labels: [
      "Order Pending",
      "Order Confirmed",
      "Order Packed",
      "Order Shipped",
      "Order Cancelled",
      "Order Delivered",
    ],
    series: [0, 0, 0, 0, 0, 0],
  });

  const [userOverViewData, setUserOverViewData] = useState({
    labels: {
      chart: {
        id: "user-overview",
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
    series: [
      {
        name: "New User",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const ordersData = useOrdersData();
  const users = useUsers();
  const products = useProducts();
  const isMounted = useIsMounted();

  //graph value//////////////

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;

      let orderPending = ordersData?.data?.filter(
        (order) => order.status === "pending"
      )?.length;
      let orderConfirmed = ordersData?.data?.filter(
        (order) => order.status === "processing"
      )?.length;
      let orderPacked = ordersData?.data?.filter(
        (order) => order.status === "packed"
      )?.length;
      let orderShipped = ordersData?.data?.filter(
        (order) => order.status === "shipped"
      )?.length;
      let orderCancelled = ordersData?.data?.filter(
        (order) => order.status === "cancelled"
      )?.length;
      let orderDelivered = ordersData?.data?.filter(
        (order) => order.status === "delivered"
      )?.length;

      setOrderOverViewData({
        labels: [
          "Order Pending",
          "Order Confirmed",
          "Order Packed",
          "Order Shipped",
          "Order Cancelled",
          "Order Delivered",
        ],
        series: [
          orderPending,
          orderConfirmed,
          orderPacked,
          orderShipped,
          orderCancelled,
          orderDelivered,
        ],
      });
    }
  }, [isMounted, ordersData?.data]);

  useEffect(() => {
    if (isMounted.current) {
      if (!users?.data) return;

      let janUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "January";
      })?.length;

      let febUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "February";
      })?.length;

      let marchUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "March";
      })?.length;

      let aprilUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "April";
      })?.length;

      let mayUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "May";
      })?.length;

      let juneUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "June";
      })?.length;

      let julyUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "July";
      })?.length;

      let augUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "August";
      })?.length;

      let septUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "September";
      })?.length;

      let octUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "October";
      })?.length;

      let novUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "November";
      })?.length;

      let decUser = users?.data?.filter((item) => {
        return moment(parseInt(item?.createdAt)).format("MMMM") === "December";
      })?.length;

      setUserOverViewData({
        labels: {
          chart: {
            id: "user-overview",
          },
          xaxis: {
            categories: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
          },
        },
        series: [
          {
            name: "New User",
            data: [
              janUser,
              febUser,
              marchUser,
              aprilUser,
              mayUser,
              juneUser,
              julyUser,
              augUser,
              septUser,
              octUser,
              novUser,
              decUser,
            ],
          },
        ],
      });
    }
  }, [isMounted, users?.data]);

  //card values/////////////////////
  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      let totalSold = ordersData?.data?.filter((order) => {
        return order.delivered === true;
      });
      setTotalItemSold(totalSold?.length);
    }
  }, [ordersData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      const priorDate = moment().subtract(30, "days").valueOf();
      let orders = ordersData?.data?.filter((order) => {
        return order?.createdAt > priorDate;
      });
      setOrderThisMonth(orders?.length);
    }
  }, [ordersData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!users?.data) return;
      let totalUser = users?.data?.length;
      setTotalUserJoined(totalUser - 1);
    }
  }, [users?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!users?.data) return;
      const priorDate = moment().subtract(30, "days").valueOf();

      const thisMonth = users?.data?.filter((user) => {
        return parseInt(user?.createdAt) > priorDate;
      });

      setUserThisMonth(thisMonth?.length);
    }
  }, [users?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      const priorDate = moment().format("DD-MM-YYYY");

      const toDay = ordersData?.data?.filter((order) => {
        return moment(order?.createdAt).format("DD-MM-YYYY") === priorDate;
      });

      setOrderToday(toDay?.length);
    }
  }, [ordersData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      const priorDate = moment().subtract(30, "days").valueOf();

      let thisMonth = ordersData?.data?.filter((order) => {
        return order?.createdAt > priorDate && order?.delivered === true;
      });

      // console.log(thisMonth);

      let thisMonthTotal = thisMonth?.reduce((acc, curr) => {
        return acc + curr?.totalPrice;
      }, 0);

      setEarningThisMonth(thisMonthTotal);
    }
  }, [ordersData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      const priorDate = moment().format("DD-MM-YYYY");

      let thisDay = ordersData?.data?.filter((order) => {
        return moment(order?.createdAt).format("DD-MM-YYYY") === priorDate;
      });

      // console.log(thisDay);

      let thisDayTotal = thisDay?.reduce((acc, curr) => {
        return acc + curr?.totalPrice;
      }, 0);

      setEarningToday(thisDayTotal);
    }
  }, [ordersData?.data, isMounted]);

  useEffect(() => {
    if (isMounted.current) {
      if (!ordersData?.data) return;
      let pending = ordersData?.data?.filter((order) => {
        return order?.delivered === false && order?.status !== "canceled";
      }).length;

      setPendingOrder(pending);
    }
  }, [ordersData?.data, isMounted]);

  // console.log(ordersData?.data);

  /////////////////////card values/////////////////////////////

  useEffect(() => {
    if (isMounted?.current) {
      if (!products?.data) return;
      if (products?.data && products?.data.length > 0) {
        let sortedProduct = [...products?.data]?.sort((a, b) => {
          return b?.totalSold - a?.totalSold;
        });
        setTopProducts(sortedProduct?.slice(0, 5));
      }
    }
  }, [products?.data, isMounted]);
  useEffect(() => {
    if (isMounted?.current) {
      if (!users?.data) return;
      if (users?.data && users?.data.length > 0) {
        let sortedUsers = users?.data?.sort((a, b) => {
          return parseInt(b?.createdAt) - parseInt(a?.createdAt);
        });
        setNewCustomer(sortedUsers?.slice(0, 5));
      }
    }
  }, [users?.data, isMounted]);

  useEffect(() => {
    if (isMounted?.current) {
      if (ordersData?.data && ordersData?.data.length > 0) {
        let dataArray = [];

        ordersData?.data?.map((order) => {
          return order?.products?.map((orderedProduct, index) => {
            dataArray.push({
              ...order,
              orderId: order?.id,
              id: order?.id + "-" + index,
              products: {
                ...orderedProduct,
              },
            });

            return dataArray;
          });
        });

        let sl = 0;

        let sortedData = dataArray
          ?.sort((a, b) => {
            return b?.createdAt - a?.createdAt;
          })
          .map((data) => {
            sl += 1;
            return {
              ...data,
              sl: sl,
            };
          });

        setRecentOrder(sortedData?.slice(0, 10));
      }
    }
  }, [ordersData?.data, isMounted]);

  // console.log(recentOrder);

  return (
    <main className="w-100">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg={"linear-gradient(45deg, #009eff, #00c8ff)"}
            icon={
              <InventoryOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Item Sold"}
            content={totalItemSold}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg=" linear-gradient(315deg, #f7b42c 0%, #fc575e 74%)
          "
            icon={
              <LocalOfferOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Ordered This Month"}
            content={orderedThisMonth}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg="linear-gradient(326deg, #a4508b 0%, #5f0a87 74%)"
            icon={
              <Person
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"People Joined"}
            content={totalUserJoined}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg=" linear-gradient(315deg, #485461 0%, #28313b 74%)"
            icon={
              <TimelineOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Visitors This Month"}
            content={userThisMonth}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg=" linear-gradient(315deg, #f7b42c 0%, #fc575e 74%)
          "
            icon={
              <LocalOfferOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Order Today"}
            content={orderToday}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg="linear-gradient(315deg, #861657 0%, #aa4465 74%)
            "
            icon={
              <BarChartOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Total Earnings This Month"}
            content={earningThisMonth}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg="linear-gradient(315deg, #3bb78f 0%, #0bab64 74%)
            "
            icon={
              <MoneyOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Earnings Today"}
            content={earningToday}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InfoCard
            bg=" linear-gradient(315deg, #f7b42c 0%, #fc575e 74%)
          "
            icon={
              <LocalOfferOutlined
                sx={{
                  color: "White",
                  height: "90%",
                  width: "90%",
                }}
              />
            }
            title={"Pending Orders"}
            content={pendingOrder}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ pt: 8 }}>
        <Grid item xs={12} md={12} lg={6}>
          <div className="graph-card">
            <span className="graph-card-title">Current User</span>
            <div className="w-100">
              <Chart
                options={userOverViewData?.labels}
                series={userOverViewData?.series}
                type="bar"
                width={"100%"}
                height={350}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <div className="graph-card">
            <span className="graph-card-title">Orders Overview</span>
            <div className="w-100">
              <Chart
                options={orderOverViewData}
                series={orderOverViewData.series}
                type="pie"
                width={"100%"}
                height={360}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <div className="w-100 dashboard-recent-orders ">
        <MaterialTable
          title="Recent Orders"
          isLoading={ordersData?.loading}
          data={recentOrder || []}
          options={{ ...muiTable.options() }}
          style={muiTable.styles}
          columns={[
            {
              title: "#",
              field: "sl",
              width: "5%",
              editable: "never",
              id: "sl",
            },
            {
              title: "OrderID",
              field: "orderId",
            },
            {
              title: "Product Name",
              field: "products.productName",
              emptyValue: "No value found",
              render: (rowData) => {
                return rowData.products?.productName;
              },
            },
            {
              title: "Unit",
              field: "products",
              render: (rowData) => {
                return rowData.products?.orderedQty + " Unit";
              },
            },
            {
              title: "Ordered Date",
              field: "createdAt",
              type: "date",
              render: (rowData) => {
                return moment(parseInt(rowData?.createdAt)).format(
                  "DD-MMM-YYYY"
                );
              },
            },
            {
              title: "Order Price",
              field: "totalPrice",
              render: (rowData) => {
                return formatCurrency(rowData.products?.price, "SAR");
              },
            },
            {
              title: "Supplier",
              field: "products.supplierName",
              emptyValue: "No value found",
              render: (rowData) => {
                return rowData?.products?.supplierName
                  ?.trim()
                  .replace(/^\w/, (c) => c.toUpperCase());
              },
            },
            {
              title: "Status",
              field: "status",
              render: (rowData) => {
                if (rowData.status === "pending") {
                  return (
                    <Chip color="primary" label="Pending" variant="outlined" />
                  );
                } else if (rowData.status === "processing") {
                  return (
                    <Chip
                      color="secondary"
                      label="Shipped"
                      variant="outlined"
                    />
                  );
                } else if (rowData.status === "delivered") {
                  return (
                    <Chip
                      color="success"
                      label="Delivered"
                      variant="outlined"
                    />
                  );
                } else if (rowData.status === "canceled") {
                  return (
                    <Chip color="error" label="Canceled" variant="outlined" />
                  );
                } else {
                  return (
                    <Chip
                      color="warning"
                      label="Processing"
                      variant="outlined"
                    />
                  );
                }
              },
            },
          ]}
        />
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={6}>
          <div className="dashboard-new-user">
            <div className="w-100 new-user-title ">New Customer</div>
            <div className="flex-column gap-1 dashboard-user-container ">
              {newCustomer &&
                newCustomer?.map((user, index) => {
                  return (
                    <span
                      className="w-100 flex-row justify-content-between"
                      key={index}
                    >
                      <span className="flex-row gap-2 user-details-box ">
                        <Avatar
                          src={
                            user?.photoURL ||
                            `https://avatars.dicebear.com/api/avataaars/${user?.displayName}.svg`
                          }
                          alt={user?.displayName}
                          sx={{
                            height: "4rem",
                            width: "4rem",
                            borderRadius: "50%",
                          }}
                          variant="rounded"
                        />
                        <span className="flex-column gap-1  ">
                          <h3 className="dashboard-user-name">
                            {user?.displayName}
                          </h3>
                          <h3 className="dashboard-user-email">
                            {user?.email}
                          </h3>
                        </span>
                      </span>
                      <h1 className="user-total-order">
                        {ordersData?.data?.reduce((acc, curr) => {
                          if (curr?.userId === user?.uid) {
                            return acc + 1;
                          }
                          return acc;
                        }, 0)}{" "}
                        Orders
                      </h1>
                      <h1 className="user-total-order">
                        {formatCurrency(
                          ordersData?.data?.reduce((acc, curr) => {
                            if (curr?.userId === user?.uid) {
                              return acc + curr?.totalPrice;
                            }
                            return acc;
                          }, 0)
                        )}
                      </h1>
                    </span>
                  );
                })}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <div className="dashboard-top-product">
            <div className="top-product-title">Top Products</div>
            <div className="w-100 gap-2 flex-column top-product-container">
              {topProducts &&
                topProducts?.map((product, index) => {
                  return (
                    <div
                      className="w-100 flex-row justify-content-between  "
                      key={index}
                    >
                      <span className="flex-row gap-2">
                        <Avatar
                          src={product?.images[0]?.url}
                          variant="rounded"
                          sx={{
                            height: "6rem",
                            width: "6rem",
                          }}
                        />
                        <span className="flex-column gap-1">
                          <h3 className="top-product-item-title">
                            {product?.name}
                          </h3>

                          <h3 className="top-product-desc">
                            {ReactHtmlParser(
                              product?.description?.slice(0, 50) + " ..."
                            )}
                          </h3>
                          <span className="flex-row gap-1">
                            <h3 className="top-product-price">
                              {formatCurrency(product?.price)}
                            </h3>
                            <h3 className="top-product-discounted-price">
                              {product?.discount &&
                                formatCurrency(
                                  (product?.price * (100 + product?.discount)) /
                                    100
                                )}
                            </h3>
                          </span>
                        </span>
                      </span>
                      <span className="top-product-sale-volume">
                        {product?.totalSold} Sales
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
        </Grid>
      </Grid>
    </main>
  );
};

export default Dashboard;
